<template>
  <v-dialog
    v-model="show"
  >
    <v-card
      class="mx-auto"
    >
      <div class="img-container">
        <div class="grad-img">
          <v-img
            max-height="180"
            :src="image"
            gradient="to bottom, rgba(93,93,93,.5), rgba(0,0,0,.8)"
          >
          </v-img>
        </div>
        <v-btn
          class="button-close"
          icon
          @click="close()"
        >
          <v-icon
            color="black"
          >
            mdi-close-thick
          </v-icon>
        </v-btn>
        <div class="product-title">{{ titleTranslate }}</div>
        <div class="product-description">{{ descriptionTranslate }}</div>
      </div>

      <v-card-title class="text-title">{{ textProductPopupQtyTranslated }}</v-card-title>

      <v-card-text>
        <v-row justify="space-between">
          <v-col cols="7">
            <counter-block @add="addQty" @subtract="subtractQty" :counter="qty" />
          </v-col>
          <v-col cols="4">
            <v-select
              :items="splitPrices"
              v-model="selectPrice"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mx-4"></v-divider>

      <v-card-title class="pb-0 text-title">{{ textProductPopupCommentTranslated }}</v-card-title>

      <v-card-text>
        <div class="mb-2">{{ textProductPopupSpecialTextCommentTranslated }}</div>
        <v-textarea
          no-resize
          rows="2"
          outlined
          placeholder="e.g. less spices"
          v-model="comments"
        ></v-textarea>
      </v-card-text>

      <v-card-actions>
        <div class="action-content">
          <div class="total-price">
            <span>$</span>{{calculatePrice}}
          </div>
          <v-btn
            class="action-add"
            color="black"
            large
            :style="textBtnStyle"
            @click="addProduct"
          >
            <span>{{ textProductPopupAddBtnTranslated }}</span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import {MultiLanguageText, TextProps} from '../models';
import CounterBlock from './CounterBlock.vue';

export default {
  name: 'product-popup-block',
  components: { CounterBlock },
  props: {
    title: { type: Object, required: true, default: () => null },
    description: { type: Object, default: () => null },
    image: { type: String },
    value: Boolean,
    productPrices: String,
    textProductPopupQty: { type: Object, required: true, default: () => null },
    textProductPopupComment: { type: Object, required: true, default: () => null },
    textProductPopupSpecialTextComment: { type: Object, required: true, default: () => null },
    textProductPopupAddBtn: { type: Object, required: true, default: () => null },
    shopTextBtnProps: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      qty: 1,
      comments: '',
      selectPrice: 0,
    };
  },
  computed: {
    ...mapGetters(['selectedLanguage']),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    myShopTextBtnProps() {
      return new TextProps(this.shopTextBtnProps);
    },
    textBtnStyle() {
      return this.myShopTextBtnProps.getStyles();
    },
    myTitle() {
      return new MultiLanguageText(this.title);
    },
    myDescription() {
      return new MultiLanguageText(this.description);
    },
    myTextProductPopupQty() {
      return new MultiLanguageText(this.textProductPopupQty);
    },
    myTextProductPopupComment() {
      return new MultiLanguageText(this.textProductPopupComment);
    },
    myTextProductPopupSpecialTextComment() {
      return new MultiLanguageText(this.textProductPopupSpecialTextComment);
    },
    myTextProductPopupAddBtn() {
      return new MultiLanguageText(this.textProductPopupAddBtn);
    },
    textProductPopupQtyTranslated() {
      return this.myTextProductPopupQty.getText(this.selectedLanguage);
    },
    textProductPopupCommentTranslated() {
      return this.myTextProductPopupComment.getText(this.selectedLanguage);
    },
    textProductPopupSpecialTextCommentTranslated() {
      return this.myTextProductPopupSpecialTextComment.getText(this.selectedLanguage);
    },
    textProductPopupAddBtnTranslated() {
      return this.myTextProductPopupAddBtn.getText(this.selectedLanguage);
    },
    titleTranslate() {
      return this.myTitle.getText(this.selectedLanguage);
    },
    descriptionTranslate() {
      return this.myDescription.getText(this.selectedLanguage);
    },
    price() {
      return this.productPrices ? parseFloat(this.productPrices.split('/')[0]) : 0.0;
    },
    splitPrices() {
      return this.productPrices.split('/').map((value) => parseFloat(value));
    },
    calculatePrice() {
      return this.qty * this.selectPrice;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    addQty() {
      this.qty += 1;
    },
    subtractQty() {
      if (this.qty > 1) {
        this.qty -= 1;
      }
    },
    addProduct() {
      this.$emit('submit', {
        totalPrice: this.calculatePrice,
        qty: this.qty,
        comments: this.comments,
        unitPrice: this.selectPrice,
      });
    }
  },
  watch: {
    price: {
      immediate: true,
      handler(newValue) {
        this.selectPrice = newValue;
      }
    }
  }
};
</script>
<style scoped lang="scss">

.img-container {
  position: relative;
  color: white;
  max-height: 180px;
  height: 180px;
}
.button-close{
  position: absolute;
  top: 0;
  right: 0;
}
.product-title{
  position: absolute;
  bottom: 40px;
  left: 10px;
  font-size: 18px;
  font-weight: bold;
}
.product-description{
  position: absolute;
  bottom: 15px;
  font-size: 15px;
  left: 10px;
}

.text-title {
  font-size: 1rem;
}

.action-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
  width: 100%;
}

.action-add span{
  margin-right: 10px;
  margin-left: 10px;
}

.total-price {
  font-weight: bold;
  color: black;
  font-size: 24px;
}

.total-price span {
  font-size: 26px;
  margin-right: 4px;
}

.grad-img {
  background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(0,0,0,0.8) 100%);
  height: 100%;
}

</style>
